import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { CircularProgress, IconButton, TextField, Tooltip } from '@mui/material';
import { AudioFile, Check, Close, Edit } from '@mui/icons-material';
import { Stack } from '@mui/material';
import ReactAudioPlayer from 'react-audio-player';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import dayjs from 'dayjs';
import { MenuItem } from '@mui/material';
import axios from 'axios';
import Axios from '../../../../../axios/Axios';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../redux/features/appSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 950,
  minHeight: 400,
  width: "auto",
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default function StudentAudioModal({studentId, iconStatus, onCloseCallback}) {

  const [open, setOpen] = useState(false);

//   set default "false" value for Module because , we don't need this module right now 
  const handleOpen = () => setOpen(false);
  const handleClose = () => {
    setOpen(false);
    // window.location.reload();
    onCloseCallback()
  }
  const [ studentAudioData, setStudentAudioData ] = useState({
    isLoading: false,
    isError: false,
    isSuccess: false,
    data: [],
    error: null
  });



  useEffect(() => {
    const controller = axios.CancelToken.source();
    if(open && !!studentId){
        (async () => {
            try{
                setStudentAudioData(prev => ({...prev, isLoading: true, isSuccess: false, isError: false, data: [], error: null}))
                let options = {
                    method: "GET",
                    url: `audio/student/admin/getresource/${studentId}`,
                    auth: true,
                    data: null,
                    token:{cancelToken: controller.token}
                };
        
                const response = await Axios(
                    options.method,
                    options.url,
                    options.auth,
                    options.data,
                    options.token,
                );

                if(response.status === 200){
                    let finalResponse = response.data.filter(data => !!data);
                    setStudentAudioData(prev => ({...prev, isSuccess: true, data: finalResponse}));
                }
            }catch(error){
                if(!axios.isCancel){
                    setStudentAudioData(prev => ({...prev, isError: true, error: error.data}))
                    console.log(error);
                }
            }
        })()
    }
    return () => {
        controller.cancel();
    }
  }, [open, studentId]);


  let jsx;

  if(studentAudioData.isLoading){
    jsx = <Box sx={{p: 5, textAlign: "center", width: "100%"}}>
            <p>Loading...</p>
        </Box>
  }

  if(studentAudioData.isError){
    jsx = <Box sx={{p: 5, textAlign: "center", width: "100%"}}>
            <p>{studentAudioData.error}</p>
        </Box>
  }

  if(studentAudioData.isSuccess && studentAudioData.data.length === 0){
    jsx = <Box sx={{p: 5, textAlign: "center", width: "100%"}}>
            <p>No audio information for this student</p>
        </Box>
  }

  if(studentAudioData.isSuccess && studentAudioData.data.length !== 0){

    jsx = (<TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell align='center'>Audio name</TableCell>
                <TableCell align="center">Audio file</TableCell>
                <TableCell align="center">Audio status</TableCell>
                <TableCell align="center">Reason</TableCell>
                <TableCell align="center">Audio audited by</TableCell>
                <TableCell align="center">Audio uploaded at</TableCell>
                <TableCell align="center">Edit</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
                {studentAudioData.data.map((row, i) => (
                    <AudioTableRow key={i} row={row}/>
                ))}
            </TableBody>
        </Table>
    </TableContainer>)
  }

  return (
    <div>
        <IconButton disabled={iconStatus.isDisable} onClick={handleOpen}>
            <Tooltip title={iconStatus.title} arrow placement="bottom">
                <AudioFile sx={iconStatus.style} />
            </Tooltip>
        </IconButton>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        audio details
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <Close/>
                    </IconButton>
                </Stack>
                <Stack py={2}>
                    {jsx}
                </Stack>
            </Box>
        </Modal>
    </div>
  );
}

function AudioTableRow({row}){

    const [ edit, setEdit ] = useState(false);
    const [ audioStatus, setAudioStatus ] = useState(null);
    const [ audioReason, setAudioReason ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const dispatch = useDispatch();
    const adminUsername = sessionStorage.getItem("username")

    useEffect(() => {
        setAudioStatus(row.audio_status);
        setAudioReason(row.audio_reason);
    }, [row]);


    async function approveStudentAudio(){
        try{
            setLoading(true);
            let options = {
                method: "PUT",
                url: `audio/student/update/by/admin/${row.audio_id}`,
                auth: true,
                data: {
                    audio_status: audioStatus,
                    audio_reason: audioReason,
                    audio_audit_by: adminUsername
                },
            };
    
            const response = await Axios(
                options.method,
                options.url,
                options.auth,
                options.data
            );

            if(response.status === 200){
                dispatch(
                    showSnackbar({
                      message: "Audio status updated successfully",
                      severity: "success",
                    })
                );
                setLoading(false);
                setEdit(false);

            }
    
        }catch(error){
            dispatch(
                showSnackbar({
                  message: "Error occured while updating audio status",
                  severity: "error",
                })
            );
            setLoading(false);

        }
      }

    return(
        <TableRow
        // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <TableCell align='center' component="th" scope="row">
                {row.audio_file_name}
            </TableCell>
            <TableCell align="center">
                <ReactAudioPlayer src={row.audio_source} controls/>
            </TableCell>
            <TableCell align="center">
                <TextField
                    sx={{
                        '& .MuiFormLabel-root.Mui-disabled': {
                            color: "black"
                        },
                        "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "black"
                        },
                    }}
                    disabled={!edit}
                    select
                    variant='standard'
                    value={audioStatus}
                    onChange={(e) => setAudioStatus(e.target.value)}
                    inputProps={{ IconComponent: () => null }}
                    InputProps={{ disableUnderline: !edit }}

                >
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="resend">Resend</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                </TextField>
            </TableCell>
            <TableCell sx={{minWidth: 250}} align="center">
                {edit ? <TextField
                    disabled={!edit}
                    multiline
                    rows={2}
                    variant='standard'
                    value={audioReason}
                    onChange={(e) => setAudioReason(e.target.value)}
                    InputProps={{ disableUnderline: !edit }}
                /> : audioReason}
            </TableCell>
            <TableCell align="center">{row.audio_audit_by}</TableCell>
            <TableCell align="center">{dayjs(row.audio_uploaded_at).format("DD-MM-YY, h:mm A")}</TableCell>
            <TableCell align="center">
                { edit ? 
                    <IconButton disabled={loading} onClick={approveStudentAudio}>
                        <Check/>
                    </IconButton> 
                    : 
                    <IconButton onClick={() => setEdit(true)}>
                        <Edit/>
                    </IconButton>
                }
            </TableCell>
        </TableRow>
    )
}